import { useEffect, useMemo, useState } from "react"
import { RoutePath, useRoutesHooks } from "../../../../../features/routes"
import { PanelLoader, useGetCrumbs, useUIStateActions } from "../../../../../features/ui"
import { Operation, operationHelpers } from "../../../../operations"
import { DeliveryOrder } from "../../../state/types"
import { useDeliveryOrderLoaders } from "../../../loaders/deliveryOrderLoaders"
import { CancelItemsForm } from "./cancelItemsForm"
import { useDescribeHooks } from "../../../../../features/data-types"
import { TableName } from "../../../../../tables"
import { FiscalDocument, useFiscalDocumentLoaders } from "../../../../fiscal-documents"

export const CancelItemsFormLoader = () => {
    const { tableName, dataType } = useRoutesHooks().parseUrl()
    const table = tableName!
    const operation = dataType! as Operation

    const [ready, setReady] = useState(false)
    const [deliveryOrders, setDeliveryOrders] = useState<DeliveryOrder[]>([])
    const [fiscalDocuments, setFiscalDocuments] = useState<FiscalDocument[]>([])

    const { describeCode } = operationHelpers
    const { describe } = useDescribeHooks()

    const deliveryOrderLoaders = useDeliveryOrderLoaders()
    const fiscalDocumentLoaders = useFiscalDocumentLoaders()

    const { setDisableBranchSelector } = useUIStateActions()

    const isSale = useMemo(() => table === TableName.SALE_ORDERS, [])
    const routePath = useMemo(() => isSale ? RoutePath.SALES : RoutePath.HOARDS, [])

    const load = async () => {
        const { loadOperationDeliveryOrders } = deliveryOrderLoaders()
        const { loadOperationFiscalDocuments } = fiscalDocumentLoaders()
        const [loadedDeliveryOrders, loadedFiscalDocuments] = await Promise.all([
            loadOperationDeliveryOrders(operation.id),
            loadOperationFiscalDocuments(operation.id)
        ])
        setDeliveryOrders(loadedDeliveryOrders)
        setFiscalDocuments(loadedFiscalDocuments)
    }

    useEffect(() => {
        setDisableBranchSelector(true)
        load().then(() => setReady(true))
        return () => {
            setDisableBranchSelector(false)
        }
    }, [])

    const title = `Cancelar Productos de ${describe(table, operation)}`
    const crumbs = useGetCrumbs(
        isSale ? 'Ventas' : 'Acopios',
        routePath,
        describeCode(operation),
        operation.id,
        'Cancelar Productos'
    )

    return (
        <PanelLoader
            title={title}
            crumbs={crumbs}
            ready={ready}
            wide
        >
            <CancelItemsForm
                table={table}
                operation={operation}
                deliveryOrders={deliveryOrders}
                fiscalDocuments={fiscalDocuments}
            />
        </PanelLoader>
    )
}
